module.exports = __webpack_public_path__ + "img/img-4.a265f056.png";